import styled from 'styled-components';

export const EditavelContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    padding-left: 10px;
    transition: all 0.2s ease;
    
    * {
        transition: opacity 0.2s ease, transform 0.2s ease;
    }
`;

export const ViewModeText = styled.span`
    color: ${({ theme }) => theme.colors.c000000};
    font-weight: 600;
    font-size: 12px;
    text-transform: capitalize;
    white-space: pre-wrap;
    padding-bottom: 5px;
    transition: all 0.2s ease;
    opacity: 1;
`;

export const EditModeContainer = styled.div`
    flex: 1;
    transition: all 0.2s ease;
    
    .default-input {
        min-height: auto;
        height: auto;
        margin-top: 0;
        
        input {
            height: 32px;
            padding: 6px 12px;
            margin-top: 0;
            font-size: 14px;
            border-radius: 6px;
            border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
            transition: border-color 0.2s;
            background: ${(props: any) => props.theme.colors.white};
            color: ${(props: any) => props.theme.colors.interfaceText500};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
                outline: none;
            }
        }
        
        &.error input {
            border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
                outline: none;
            }
        }
    }
    
    > label {
        min-height: auto;
        height: auto;
        
        input {
            height: 32px;
            padding: 6px 12px;
            margin-top: 0;
            font-size: 14px;
            border-radius: 6px;
            border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
            transition: border-color 0.2s;
            background: ${(props: any) => props.theme.colors.white};
            color: ${(props: any) => props.theme.colors.interfaceText500};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
                outline: none;
            }
        }
        
        &.error input {
            border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
                outline: none;
            }
        }
    }
`;

export const ErrorMessage = styled.span`
    display: block;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.primaryRed400};
    margin-top: 4px;
    min-height: 16px;
`;

